import { render } from "./InventoryList.vue?vue&type=template&id=17503fc4&scoped=true&ts=true"
import script from "./InventoryList.vue?vue&type=script&lang=ts"
export * from "./InventoryList.vue?vue&type=script&lang=ts"

import "./InventoryList.vue?vue&type=style&index=0&id=17503fc4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17503fc4"]])

export default __exports__